import {
  ExporterDestinationAzure,
  ExporterDestinationBitbucket,
  ExporterDestinationDocs,
  ExporterDestinationGithub,
  ExporterDestinationGitlab,
  ExporterDestinationS3,
  GitObjectsQuery,
  PipelineDestinationType,
  PipelineEventType,
} from "@supernova-studio/model";
import { z } from "zod";
import { DTOExporterPropertyValueMap } from "../../dto/export/exporter-property";

export const GitDestinationOptions = z.object({
  branch: z.string().min(1).nullish(),
  commitMessage: z.string().min(1).nullish(),
  commitAuthorName: z.string().min(1).nullish(),
  commitAuthorEmail: z.string().email().nullish(),
  pullRequestTitle: z.string().min(1).nullish(),
  pullRequestDescription: z.string().min(1).nullish(),
  relativePath: z.string().nullish(),
  purgeDirectory: z.boolean().nullish(),
});

export const DTOPipelineCreateBody = z.object({
  name: z.string(),
  exporterId: z.string(),
  designSystemId: z.string(),
  isEnabled: z.boolean(),
  eventType: PipelineEventType,
  brandPersistentId: z.string().optional(),
  themePersistentId: z.string().optional(),
  themePersistentIds: z.string().array().optional(),

  exporterPropertyValues: DTOExporterPropertyValueMap.optional(),

  destination: PipelineDestinationType.optional(),
  gitQuery: GitObjectsQuery,
  destinations: z.object({
    s3: ExporterDestinationS3.nullish(),
    azure: ExporterDestinationAzure.nullish(),
    bitbucket: ExporterDestinationBitbucket.nullish(),
    github: ExporterDestinationGithub.nullish(),
    gitlab: ExporterDestinationGitlab.nullish(),
    documentation: ExporterDestinationDocs.nullish(),
    webhookUrl: z.string().nullish(),
  }),
});

export const DTOPipelineUpdateBody = z.object({
  exporterId: z.string().optional(),
  name: z.string().optional(),
  isEnabled: z.boolean().optional(),
  eventType: PipelineEventType.optional(),

  brandPersistentId: z.string().optional(),
  themePersistentId: z.string().optional(),
  themePersistentIds: z.string().array().optional(),

  exporterPropertyValues: DTOExporterPropertyValueMap.optional(),

  destination: PipelineDestinationType.optional(),
  gitQuery: GitObjectsQuery.optional(),

  destinations: z
    .object({
      s3: ExporterDestinationS3.nullish(),
      azure: ExporterDestinationAzure.nullish(),
      bitbucket: ExporterDestinationBitbucket.nullish(),
      github: ExporterDestinationGithub.nullish(),
      gitlab: ExporterDestinationGitlab.nullish(),
      documentation: ExporterDestinationDocs.nullish(),
      webhookUrl: z.string().nullish(),
    })
    .optional(),
  gitDestinationOptions: GitDestinationOptions.partial().optional(),
});

export const DTOPipelineTriggerBody = z.object({
  designSystemVersionId: z.string(),
});

export type GitDestinationOptions = z.infer<typeof GitDestinationOptions>;
export type DTOPipelineCreateBody = z.infer<typeof DTOPipelineCreateBody>;
export type DTOPipelineUpdateBody = z.infer<typeof DTOPipelineUpdateBody>;
export type DTOPipelineTriggerBody = z.infer<typeof DTOPipelineTriggerBody>;
